module.exports = __webpack_public_path__ + "img/suzuki-ertiga.e6e170f2.jpg";